import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
export function TermsOfService() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-white text-black transition-colors duration-500" data-id="element-610">
      {/* Header */}
      <header className="fixed top-0 left-0 w-full bg-white/80 backdrop-blur-md border-b border-black/5 z-50" data-id="element-611">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-612">
          <a href="/" className="flex items-center hover:opacity-80 transition-opacity" data-id="element-613">
            <img src="https://cdn.magicpatterns.com/uploads/fTMKMcwziqc5vCPyjAKBhC/C14.svg" alt="Caltalk" className="h-20 w-auto" data-id="element-614" />
          </a>
          <a href="/" className="text-sm text-black/60 hover:text-coral-600 transition-colors" data-id="element-615">
            ← back to home
          </a>
        </div>
      </header>

      {/* Content */}
      <main className={`pt-32 pb-20 transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-616">
        <div className="max-w-4xl mx-auto px-6" data-id="element-617">
          {/* Title */}
          <div className="mb-16" data-id="element-618">
            <h1 className="text-4xl md:text-5xl font-light mb-4" data-id="element-619">
              Terms of Service
            </h1>
            <p className="text-black/60" data-id="element-620">Last Updated: December 10, 2025</p>
          </div>

          {/* Intro */}
          <div className="prose prose-lg max-w-none mb-12" data-id="element-621">
            <p className="text-lg text-black/80 leading-relaxed" data-id="element-622">
              Please read these Terms and Conditions carefully before accessing
              or using the Caltalk Service.
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-12" data-id="element-623">
            <Section number="1" title="Interpretation and Definitions" data-id="element-624">
              <Subsection title="1.1 Interpretation" data-id="element-625">
                <p data-id="element-626">
                  Capitalized terms have the meanings provided in this Section
                  or otherwise defined in these Terms. The definitions apply
                  regardless of whether terms appear in singular or plural.
                </p>
              </Subsection>

              <Subsection title="1.2 Definitions" data-id="element-627">
                <dl className="space-y-4" data-id="element-628">
                  <Term term="Affiliate" definition='means any entity that controls, is controlled by, or is under common control with the Company, where "control" means direct or indirect ownership of at least fifty percent (50%) of the equity interests or voting securities.' data-id="element-629" />
                  <Term term="Application" definition='means the mobile application titled "Caltalk," including all related features, tools, content, and updates.' data-id="element-630" />
                  <Term term="Company, We, Us, or Our" definition="means Caltalk, LLC, with a mailing address at 1221 Brickell Ave Suite 900, Miami, Florida 33131, United States." data-id="element-631" />
                  <Term term="Device" definition="means any device capable of accessing the Service." data-id="element-632" />
                  <Term term="Service" definition="means, collectively, the Application, the Website, associated software, content, AI-powered tools, and any services offered by the Company." data-id="element-633" />
                  <Term term="User Content" definition="means any text, meal descriptions, dietary information, metadata, or other content uploaded, submitted, or transmitted by You through the Service." data-id="element-634" />
                  <Term term="Website" definition="means caltalk.ai and any associated subdomains." data-id="element-635" />
                  <Term term="You" definition="means the individual using the Service or the legal entity on whose behalf the individual uses the Service." data-id="element-636" />
                </dl>
              </Subsection>
            </Section>

            <Section number="2" title="Agreement to Terms" data-id="element-637">
              <p data-id="element-638">
                Your access to and use of the Service is conditioned upon Your
                acceptance of these Terms and the Caltalk Privacy Policy. By
                accessing or using the Service, You acknowledge that You have
                read, understood, and agreed to be bound by these Terms. If You
                do not agree, You must discontinue use of the Service.
              </p>
            </Section>

            <Section number="3" title="Eligibility; Age Requirements" data-id="element-639">
              <p className="mb-4" data-id="element-640">
                You represent and warrant that You are at least 13 years old.
              </p>
              <p data-id="element-641">
                If You are between 13 and 17 years old, You may only use the
                Service with the consent and supervision of a parent or legal
                guardian, who agrees to be fully responsible for all activities
                conducted using the Service.
              </p>
            </Section>

            <Section number="4" title="Health, Nutrition, and Safety Disclaimers" data-id="element-642">
              <div className="bg-coral-50/50 border border-coral-500/20 rounded-2xl p-6 mb-6" data-id="element-643">
                <p className="font-medium text-coral-700 mb-2" data-id="element-644">Important:</p>
                <p className="text-black/80" data-id="element-645">
                  Caltalk does not provide medical advice, nutritional
                  counseling, or professional health services. All macro
                  calculations, nutritional insights, and restaurant
                  recommendations are automated approximations and may be
                  incomplete or inaccurate.
                </p>
              </div>
              <ul className="space-y-2 list-disc list-inside text-black/70" data-id="element-646">
                <li data-id="element-647">
                  Macro calculations and nutrition estimates are approximations
                  only.
                </li>
                <li data-id="element-648">
                  Restaurant menu information is provided by third parties and
                  may not reflect current offerings or nutritional accuracy.
                </li>
                <li data-id="element-649">
                  The Service is not intended to diagnose, treat, cure, or
                  prevent any disease.
                </li>
                <li data-id="element-650">
                  You should consult licensed professionals for dietary or
                  medical guidance.
                </li>
                <li data-id="element-651">
                  The Company is not liable for inaccuracies in macro counts,
                  calorie information, or restaurant recommendations.
                </li>
              </ul>
            </Section>

            <Section number="5" title="User Content; License Grant" data-id="element-652">
              <p className="mb-4" data-id="element-653">
                By submitting User Content, You represent that You own or have
                rights to it. You grant the Company a worldwide, irrevocable,
                royalty-free, transferable, sublicensable license to use,
                reproduce, analyze, process, modify, publish, and create
                derivative works from the User Content to operate and improve
                the Service, including training AI models.
              </p>
              <p data-id="element-654">
                You agree not to upload unlawful, harmful, offensive, or
                infringing content.
              </p>
            </Section>

            <Section number="6" title="Prohibited Uses" data-id="element-655">
              <p className="mb-4" data-id="element-656">You agree not to:</p>
              <ul className="space-y-2 list-disc list-inside text-black/70" data-id="element-657">
                <li data-id="element-658">Upload violent, explicit, or unlawful content</li>
                <li data-id="element-659">Engage in reverse engineering or competitive analysis</li>
                <li data-id="element-660">Circumvent protections or gain unauthorized access</li>
                <li data-id="element-661">Provide false or misleading information</li>
                <li data-id="element-662">Interfere with the Service's operation</li>
                <li data-id="element-663">Use the Service to spam or harass others</li>
                <li data-id="element-664">Collect user data without authorization</li>
                <li data-id="element-665">
                  Use automated systems (bots, scrapers) without written
                  permission
                </li>
              </ul>
            </Section>

            <Section number="7" title="Subscription, Billing, and In-App Purchases" data-id="element-666">
              <p className="mb-4" data-id="element-667">
                Purchases and subscriptions are processed through third-party
                platforms such as the Apple App Store and Google Play Store.
                Their terms govern payment processing, renewals, and refunds.
              </p>
              <p className="mb-4" data-id="element-668">
                Subscriptions automatically renew unless cancelled at least 24
                hours before the current period ends.
              </p>
              <p data-id="element-669">
                The Company reserves the right to modify pricing at any time.
                Changes to subscription pricing will be communicated to You in
                advance.
              </p>
            </Section>

            <Section number="8" title="Third-Party Services and Restaurant Data" data-id="element-670">
              <p className="mb-4" data-id="element-671">
                The Service may include links to or integrations with
                third-party content, services, or restaurant databases. The
                Company does not control and is not responsible for:
              </p>
              <ul className="space-y-2 list-disc list-inside text-black/70" data-id="element-672">
                <li data-id="element-673">
                  Accuracy of third-party restaurant menus or nutritional
                  information
                </li>
                <li data-id="element-674">Availability of restaurant menu items</li>
                <li data-id="element-675">Quality or safety of food provided by restaurants</li>
                <li data-id="element-676">Third-party privacy practices or terms of service</li>
              </ul>
            </Section>

            <Section number="9" title="Restaurant Recommendations" data-id="element-677">
              <p className="mb-4" data-id="element-678">
                Restaurant recommendations are based on Your stated preferences
                and available menu data. The Company does not:
              </p>
              <ul className="space-y-2 list-disc list-inside text-black/70 mb-4" data-id="element-679">
                <li data-id="element-680">Guarantee the accuracy of restaurant menu information</li>
                <li data-id="element-681">Endorse any specific restaurant or food item</li>
                <li data-id="element-682">
                  Warrant that recommended meals will meet Your exact
                  nutritional needs
                </li>
                <li data-id="element-683">
                  Accept responsibility for food quality, preparation, or safety
                </li>
              </ul>
              <p className="text-black/80" data-id="element-684">
                Always verify nutritional information directly with restaurants
                and consider Your individual dietary needs and restrictions.
              </p>
            </Section>

            <Section number="10" title="Intellectual Property" data-id="element-685">
              <p className="mb-4" data-id="element-686">
                All rights in the Service (excluding User Content) are owned
                exclusively by the Company or its licensors. You may not copy,
                modify, distribute, sell, or reverse engineer any part of the
                Service.
              </p>
              <p data-id="element-687">
                The Caltalk name, logo, and all related marks are trademarks of
                the Company.
              </p>
            </Section>

            <Section number="11" title="User Accounts" data-id="element-688">
              <p className="mb-4" data-id="element-689">You are responsible for:</p>
              <ul className="space-y-2 list-disc list-inside text-black/70" data-id="element-690">
                <li data-id="element-691">
                  Maintaining the confidentiality of Your account credentials
                </li>
                <li data-id="element-692">All activities that occur under Your account</li>
                <li data-id="element-693">Notifying Us immediately of any unauthorized access</li>
              </ul>
            </Section>

            <Section number="12" title="Termination" data-id="element-694">
              <p className="mb-4" data-id="element-695">
                The Company may suspend or terminate Your access at any time if
                You violate these Terms. Upon termination, all rights granted to
                You immediately cease.
              </p>
              <p className="mb-4" data-id="element-696">
                You may terminate Your account at any time through the
                Application settings or by contacting support.
              </p>
              <p className="mb-4" data-id="element-697">Upon termination:</p>
              <ul className="space-y-2 list-disc list-inside text-black/70" data-id="element-698">
                <li data-id="element-699">Your right to use the Service ends immediately</li>
                <li data-id="element-700">
                  Your data may be deleted according to Our Privacy Policy
                </li>
                <li data-id="element-701">
                  No refunds will be provided for unused subscription periods
                  unless required by law
                </li>
              </ul>
            </Section>

            <Section number="13" title='"AS IS" and "AS AVAILABLE" Disclaimer' data-id="element-702">
              <p className="mb-4" data-id="element-703">
                The Service is provided without warranties of any kind, express
                or implied. The Company disclaims all warranties including
                merchantability, fitness for a particular purpose, accuracy, and
                non-infringement.
              </p>
              <p className="mb-4" data-id="element-704">The Company does not warrant that:</p>
              <ul className="space-y-2 list-disc list-inside text-black/70" data-id="element-705">
                <li data-id="element-706">The Service will meet Your requirements</li>
                <li data-id="element-707">
                  The Service will be uninterrupted, timely, secure, or
                  error-free
                </li>
                <li data-id="element-708">
                  Results obtained from the Service will be accurate or reliable
                </li>
                <li data-id="element-709">Any errors will be corrected</li>
              </ul>
            </Section>

            <Section number="14" title="Limitation of Liability" data-id="element-710">
              <p className="mb-4" data-id="element-711">
                To the maximum extent allowed by law, the Company's total
                liability shall not exceed the greater of:
              </p>
              <ul className="space-y-2 list-disc list-inside text-black/70 mb-4" data-id="element-712">
                <li data-id="element-713">The amount You paid in the preceding 12 months, or</li>
                <li data-id="element-714">One hundred dollars (USD $100).</li>
              </ul>
              <p className="mb-4" data-id="element-715">
                The Company is not liable for indirect, incidental, or
                consequential damages, including:
              </p>
              <ul className="space-y-2 list-disc list-inside text-black/70" data-id="element-716">
                <li data-id="element-717">Loss of profits or data</li>
                <li data-id="element-718">Personal injury or property damage</li>
                <li data-id="element-719">
                  Damages resulting from dietary choices or restaurant
                  recommendations
                </li>
                <li data-id="element-720">Damages from unauthorized access to Your account</li>
                <li data-id="element-721">Damages from Service interruptions or errors</li>
              </ul>
            </Section>

            <Section number="15" title="Indemnification" data-id="element-722">
              <p className="mb-4" data-id="element-723">
                You agree to indemnify and hold harmless the Company, its
                affiliates, and their respective officers, directors, employees,
                and agents from any claims, losses, damages, liabilities, and
                expenses (including legal fees) arising from:
              </p>
              <ul className="space-y-2 list-disc list-inside text-black/70" data-id="element-724">
                <li data-id="element-725">Your use of the Service</li>
                <li data-id="element-726">Your violation of these Terms</li>
                <li data-id="element-727">Your violation of any rights of another party</li>
                <li data-id="element-728">Your User Content</li>
              </ul>
            </Section>

            <Section number="16" title="DMCA Notice" data-id="element-729">
              <p data-id="element-730">
                Copyright infringement notices may be submitted to the Company's
                designated agent as described on the Website.
              </p>
            </Section>

            <Section number="17" title="Governing Law" data-id="element-731">
              <p data-id="element-732">
                These Terms are governed by the laws of the State of Florida.
                You agree to jurisdiction in Florida courts, except where
                arbitration applies.
              </p>
            </Section>

            <Section number="18" title="Arbitration and Class Action Waiver" data-id="element-733">
              <p className="mb-4" data-id="element-734">
                Disputes must be resolved through binding individual arbitration
                administered by the American Arbitration Association. Class
                actions and representative actions are not permitted.
              </p>
              <p data-id="element-735">
                You and the Company agree that any dispute resolution
                proceedings will be conducted only on an individual basis and
                not in a class, consolidated, or representative action.
              </p>
            </Section>

            <Section number="19" title="Severability and Waiver" data-id="element-736">
              <p data-id="element-737">
                If any provision is invalid, the remaining provisions remain in
                effect. Failure to enforce a right does not constitute a waiver.
              </p>
            </Section>

            <Section number="20" title="Changes to These Terms" data-id="element-738">
              <p data-id="element-739">
                The Company may update these Terms at any time. Material changes
                will be announced through reasonable notice via email or in-app
                notification. Continued use after updates constitutes
                acceptance.
              </p>
            </Section>

            <Section number="21" title="Entire Agreement" data-id="element-740">
              <p data-id="element-741">
                These Terms, together with Our Privacy Policy, constitute the
                entire agreement between You and the Company regarding the
                Service.
              </p>
            </Section>

            <Section number="22" title="Contact Information" data-id="element-742">
              <p className="mb-4" data-id="element-743">
                If You have questions about these Terms, You may contact Us at:
              </p>
              <div className="bg-black/5 rounded-2xl p-6 space-y-2" data-id="element-744">
                <p data-id="element-745">
                  <span className="font-medium" data-id="element-746">Email:</span>{' '}
                  <a href="mailto:info@caltalk.ai" className="text-coral-600 hover:underline" data-id="element-747">
                    info@caltalk.ai
                  </a>
                </p>
                <p data-id="element-748">
                  <span className="font-medium" data-id="element-749">Mailing Address:</span>
                  <br data-id="element-750" />
                  Caltalk, LLC
                  <br data-id="element-751" />
                  1221 Brickell Ave Suite 900
                  <br data-id="element-752" />
                  Miami, Florida 33131
                  <br data-id="element-753" />
                  United States
                </p>
              </div>
            </Section>
          </div>
        </div>
      </main>
    </div>;
}
interface SectionProps {
  number: string;
  title: string;
  children: React.ReactNode;
}
function Section({
  number,
  title,
  children
}: SectionProps) {
  return <section className="scroll-mt-32" data-id="element-754">
      <h2 className="text-2xl font-light mb-6 flex items-baseline gap-3" data-id="element-755">
        <span className="text-coral-600" data-id="element-756">{number}.</span>
        <span data-id="element-757">{title}</span>
      </h2>
      <div className="text-black/70 leading-relaxed space-y-4" data-id="element-758">{children}</div>
    </section>;
}
interface SubsectionProps {
  title: string;
  children: React.ReactNode;
}
function Subsection({
  title,
  children
}: SubsectionProps) {
  return <div className="mt-6" data-id="element-759">
      <h3 className="text-lg font-medium mb-4 text-black/90" data-id="element-760">{title}</h3>
      <div className="text-black/70 leading-relaxed" data-id="element-761">{children}</div>
    </div>;
}
interface TermProps {
  term: string;
  definition: string;
}
function Term({
  term,
  definition
}: TermProps) {
  return <div data-id="element-762">
      <dt className="font-medium text-black/90 mb-1" data-id="element-763">{term}</dt>
      <dd className="text-black/70 ml-4" data-id="element-764">{definition}</dd>
    </div>;
}